import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi, adminApi } from '../utils/api';

export function LandingPage() {
  const [accessCode, setAccessCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!accessCode.trim()) {
      setError('Please enter your access code');
      return;
    }
    setLoading(true);
    setError(null);

    const code = accessCode.trim().toUpperCase();

    try {
      // Try team member login first
      const userResult = await authApi.login(code);
      if (userResult.success && userResult.user) {
        localStorage.setItem('rewagent_user', JSON.stringify(userResult.user));
        navigate('/dashboard');
        return;
      }
    } catch {
      // Team member login failed, try admin
    }

    try {
      // Try admin login
      const adminResult = await adminApi.loginWithAccessCode(code);
      if (adminResult.success && adminResult.admin) {
        localStorage.setItem('rewagent_admin', JSON.stringify(adminResult.admin));
        navigate('/admin/dashboard');
        return;
      }
    } catch {
      // Admin login also failed
    }

    setError('Invalid access code');
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#f3ede3] flex flex-col font-[Inter]">

      {/* Main Content */}
      <main className="relative z-10 flex-1 flex flex-col items-center justify-center p-6">
        <div className="w-full max-w-sm text-center">
          <div className="flex justify-center mb-8">
            <img src="/logo-light.png" alt="REWagent" className="h-12 w-auto" />
          </div>
          <h1 className="text-3xl font-bold text-[#1a1a1a] mb-2 tracking-tight">Lead Management</h1>
          <p className="text-[#6b635a] mb-10 text-sm">Enter your access code to continue</p>

          <form onSubmit={handleSubmit} className="bg-[#fcfbfa] border border-[#e3dbcf] rounded-xl p-8 shadow-sm">
            <div className="mb-6 text-left">
              <label className="text-xs font-semibold text-[#8c8578] uppercase tracking-widest mb-3 block">Access Code</label>
              <input
                type="text"
                value={accessCode}
                onChange={(e) => setAccessCode(e.target.value.toUpperCase())}
                placeholder="ENTER CODE"
                maxLength={16}
                className="w-full bg-[#f3ede3] border border-[#e3dbcf] rounded-lg text-[#1a1a1a] font-mono text-center text-lg px-4 py-3 focus:outline-none focus:border-[#1a1a1a] placeholder:text-[#b8b0a5] transition-all tracking-widest"
                autoFocus
                autoComplete="off"
              />
            </div>

            {error && (
              <div className="mb-5 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3.5 bg-[#1a1a1a] hover:bg-[#000000] text-[#f3ede3] font-medium rounded-lg transition-all disabled:opacity-50"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  Verifying...
                </span>
              ) : 'Continue'}
            </button>

            <p className="mt-5 text-xs text-[#8c8578]">Need access? Contact your administrator</p>
          </form>
        </div>
      </main>

      <footer className="relative z-10 text-center py-6 text-xs text-[#8c8578]">
        © 2026 REWagent
      </footer>
    </div>
  );
}
